export default {
  filter: 'Filter',
  btnReset: 'Reset',
  inputFrom: 'From',
  inputTo: 'To',
};
